<ng-template #delete>
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content custom-modal">

        <div class="modal-body text-center">

          <div class="icon-warning mb-3">
            <svg width="52" height="52" viewBox="0 0 24 24" fill="none"
              stroke="#ff6347" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>

          <h5 class="warning-title">Warning</h5>

          <p class="main-message">
            Are you sure you want to delete this <strong>{{details}}</strong>?
          </p>

          <div class="d-flex justify-content-center gap-2 mt-4">
            <button class="btn btn-danger me-1 rounded hover-animates" (click)="confirm()">
              <i class="bi bi-trash3-fill me-1"></i> Delete
            </button>

            <button class="btn btn-secondary me-1 rounded hover-animates" (click)="closeModel()">
              <i class="bi bi-x-circle me-1"></i> Cancel
            </button>
          </div>

        </div>

      </div>
    </div>
  </div>

</ng-template>